import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/AdminLoginStyles.css";
import API_URL from "../../config";

function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ user: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user: form.user,
          password: form.password,
        }),
      });

      if (!response.ok) {
        throw new Error("Credenciales inválidas");
      }

      const data = await response.json();
      localStorage.setItem("adminToken", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div
      className="unique-cover-container d-flex flex-column justify-content-between"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/adminImages/login.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header className="unique-admin-header">
        <div>
          <h3 className="unique-header-title text-white">
            Constructora Cantabria S.A.S
          </h3>
        </div>
      </header>

      {/* Main Content */}
      <main className="unique-login-content text-center text-white">
        <h1 className="unique-login-title">Admin Login</h1>
        <p className="unique-login-subtitle">
          Ingresa tus credenciales para acceder al panel administrativo.
        </p>
        <form
          className="unique-login-form p-4 mx-auto"
          style={{ maxWidth: "400px" }}
          onSubmit={handleSubmit}
        >
          {error && <p className="error-text text-danger">{error}</p>}
          <div className="mb-3 text-start">
            <label htmlFor="user" className="form-label">
              Usuario
            </label>
            <input
              type="text"
              id="user"
              name="user"
              className="form-control"
              value={form.user}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3 text-start">
            <label htmlFor="password" className="form-label">
              Contraseña
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              value={form.password}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="unique-login-button btn w-100">
            Ingresar
          </button>
        </form>
      </main>

      {/* Footer */}
      <footer className="unique-admin-footer text-center text-white-50 py-3">
        <p>Panel de administración | Constructora Cantabria © 2024</p>
      </footer>
    </div>
  );
}

export default AdminLogin;
